import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  dialogClose: {
    marginLeft: 'auto',
    padding: theme.spacing(3),
    paddingTop: 19,
  },
  links: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
  },
  link: {
    fontWeight: 700,
    marginRight: 14,
    '&:first-child': {
      marginRight: theme.spacing(4),
    },
  },
  socialBox: {
    width: '100%',
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  divider: {
    display: 'flex',
    padding: [0, theme.spacing(3)],
    justifyContent: 'space-between',
  },
  line: {
    width: '45%',
    marginTop: 10,
    borderTop: [1, 'solid', theme.palette.colors.border],
  },
}));



// WEBPACK FOOTER //
// ./src/components/Login/useStyles.js